export default __webpack_public_path__ + "static/media/contact-info-icon-active.975ad24f.svg";